/**
 * Manage payment methods in confirm page. Send to backend the payment method selected and change totals
 *
 * @author: Pietro Vignola <pvignola[at]kooomo[dot]com>
 *
 */

/**
 * @event document#zg-error Generic error. Used by 2002-zg-notifier.js to display the error
 * @type {object}
 * @property {string} eventType - Typology of event.
 * @property {string} message - The error message.
 */

/**
 * @event document#zg.selectPayment.paymentReady Form for select payment method is ready
 * @type {object}
 * @property {int} - id of payment method selected
 * @property {string} - payment info if there is data-payment-info in html of the selector
 */

(function ( $, _ ) { /* global JS_TRANSLATIONS, makeUrl, ZG_CONFIG */
	'use strict';

	/**
	 * @selector data-zg-role="select-payment-method" The plugin start if there is the selector in the dom when the page load
	 */

	var selector = '[data-zg-role="select-payment-method"]';

	/**
	 * @param {string} [selector] Radio button with payment method value
	 */

	var DEFAULTS = {
		selector: 'input[name="paymentRadios"]'
	};

	// SELECT PAYMENT CLASS DEFINITION
	// ================================

	/**
	 *
	 * @param {HTMLElement} element
	 * @param {!object}     options
	 *
	 * @constructor
	 */
	var SelectPayment = function ( element, options ) {
		this.$element = $( element );
		this.options  = _.extend( {}, DEFAULTS, options || {} );

		this.url = makeUrl( { module: 'eshop', manager: 'eshop', action: 'applyPaymentMethodFee' } );

		this.__setEventHandlers();
		this.__init();
	};


	/**
	 * @method request
	 * @fires document#zg-error Payment not selectable
	 */

	/**
	 * @method request
	 * @fires document#zg.selectPayment.paymentReady After click on payment method, call ajax for change it and set payment details in the page
	 */

	SelectPayment.prototype.request = function ( paymentInfo ) {
		this.$element.addClass( 'loading' );

		$.ajax( {
			type:     'POST',
			url:      this.url,
			data:     { 'paymentMethod': paymentInfo || '' },
			dataType: 'json',

			success: function ( response ) {
				if ( response.fee == 0 ) {
					$( '[data-zg-role="payment-cost-container"]' ).addClass( 'hidden' );
				} else {
					$( '[data-zg-role="payment-cost-container"]' ).removeClass( 'hidden' );
				}

				$( '[data-zg-role="payment_cost"]' ).html( window.renderPrice( response.fee ) );
				$( '[data-zg-role="discountAmount"]' ).html( window.renderPrice( response.discountAmount ) );
				$( '[data-zg-role="total_sum"]' ).html( window.renderPrice( response.total_sum ) );

				$( '[data-zg-role="payments"]' ).removeClass( 'hidden' );

				$( document ).trigger( 'zg.selectPayment.paymentReady', [paymentInfo] );
			},

			error: function () {
				$( '[data-zg-role="payments"]' ).addClass( 'hidden' );

				$( document ).trigger(
					'zg-error',
					[{
						eventType: 'SelectPayment',
						message:   JS_TRANSLATIONS.payment_not_selectable || 'Payment not selectable'
					}]
				);
			},

			complete: (function () {
				this.$element.removeClass( 'loading' );
			}).bind( this )
		} );
	};


	/**
	 * Select the first payment method if none is selected
	 *
	 * @private
	 */
	/**
	 * @method __init
	 * @fires document#zg.selectPayment.paymentReady On init of the plugin, check if there is a method checked otherwise click the first
	 */
	SelectPayment.prototype.__init = function () {
		var $selected = this.$element.find( this.options.selector + ':checked' );

		if ( $selected.length ) {
			$( document ).trigger( 'zg.selectPayment.paymentReady', [$selected.data( 'payment-info' )] );
		} else {

			if(this.$element.find( this.options.selector ).first().prop('disabled'))
				this.$element.find( this.options.selector ).last().prop( 'checked', true ).change();
			else
				this.$element.find( this.options.selector ).first().prop( 'checked', true ).change();
		}
	};


	/**
	 * @method __setEventHandlers
	 * @listen document#change.zg.selectPayment On radio checked change, call the ajax function
	 */

	SelectPayment.prototype.__setEventHandlers = function () {
		this.$element.on( 'change.zg.selectPayment', this.options.selector, (function ( e ) {
			var $target = $( e.currentTarget );

            $target.closest('a').tab('show'); // Show the correct tab

			this.request( $target.data( 'payment-info' ) );
		}).bind( this ) );
	};


	// SELECT PAYMENT PLUGIN DEFINITION
	// =================================

	function Plugin ( option ) {
		return this.each( function () {
			var $this   = $( this );
			var data    = $this.data( 'zg.selectPayment' );
			var options = _.extend( {}, ZG_CONFIG || {}, $this.data(), typeof option === 'object' && option );

			if ( !data ) {
				$this.data( 'zg.selectPayment', new SelectPayment( this, options ) );
			}
		} );
	}

	$.fn.zgSelectPayment             = Plugin;
	$.fn.zgSelectPayment.Constructor = SelectPayment;


	// SELECT PAYMENT DATA-API
	// ========================

	$( function () {
		$( selector ).each( function () {
			Plugin.call( $( this ) );
		} );
	} );


}( jQuery, _ ));
